import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ITable } from '@common/models/table';
import * as supplierOtherCreditorActions from '@feature/suppliers/actions/supplier-other-creditors.actions';
import { SupplierOtherCreditorHttpService } from '@feature/suppliers/services/supplier-other-creditor-http.service';

@Injectable()
export class SupplierOtherCreditorEffects {

  constructor(
    private readonly actions$: Actions,
      private readonly supplierOtherCreditorHttpService: SupplierOtherCreditorHttpService
  ) { }

  loadEffect$ = createEffect(() => this.actions$.pipe(
      ofType(supplierOtherCreditorActions.load),
    switchMap(action => {
        return this.supplierOtherCreditorHttpService.getSupplierOtherCreditors().pipe(
            map(payload => supplierOtherCreditorActions.loadComplete({ payload }))
      );
    })
  ));
}

